import { render, staticRenderFns } from "./ControlDrugAdminDetail.vue?vue&type=template&id=2376e33c&scoped=true"
import script from "./ControlDrugAdminDetail.vue?vue&type=script&lang=js"
export * from "./ControlDrugAdminDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2376e33c",
  null
  
)

export default component.exports